var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendarIcon = function SvgCalendarIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#545454",
    d: "M15.5 2.545v2.728H.5V2.545h2.727V.5h2.046v2.045h5.454V.5h2.046v2.045zm-15 3.41h15v8.181c0 .753-.61 1.364-1.364 1.364H1.864C1.11 15.5.5 14.89.5 14.136zm10.227 4.09h2.727V7.319h-2.727zm-4.09 0h2.727V7.319H6.636zm0 4.091h2.727V11.41H6.636zm-4.092-4.09h2.728V7.318H2.545zm0 4.09h2.728V11.41H2.545z"
  })));
};
export default SvgCalendarIcon;